import ViewFiltersModal from './ViewFiltersModal.vue';

export default ViewFiltersModal;
